import FileUploadButton from "@components/fileUploadButton/FileUploadButton";
import SmartTableManager from "@components/smart/smartTable/SmartTableManager";
import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import customFetch from "@utils/customFetch";
import React, { useCallback } from "react";

import { Status } from "../../enums";
import { FormStorage } from "../../views/formView/FormStorage";


interface IProps {
    storage: FormStorage;
}

async function uploadFileToRossum(file: File, rossumDocumentId: string | number): Promise<boolean> {
    const apiURL = `api/public/fakeRossum/finishProcessing/${rossumDocumentId}`;

    try {
        const formData = new FormData();
        formData.append("file", file);
        const response = await customFetch(apiURL, {
            method: "POST",
            body: formData
        });

        return !!response.ok;
    } catch (e) {
        return false;
    }
}

const RossumUploadResult: React.FunctionComponent<IProps> = ({ storage }) => {

    const [busy, setBusy] = React.useState(false);

    const handleFileAttached = useCallback((files: File[]) => {
        setBusy(true);

        const params = storage.data.entity.Parameters;
        const parsedParams = params ? JSON.parse(params) : {};

        uploadFileToRossum(files[0], parsedParams.RossumDocumentId)
                .then((result: boolean) => {
                    setBusy(false);
                    if (result === true) {
                        // success, just reload the form, button will disappear and BJ will change status
                        storage.reload();
                        SmartTableManager.getTable(`${EntityTypeName.BackgroundJob}Table`).reloadTable();
                    } else {
                        // show error
                        storage.setFormAlert({
                            status: Status.Error,
                            title: "Nahrání výsledku z Rossum se nezdařilo."
                        });
                        storage.refresh(true);
                    }
                });
    }, [storage]);

    return (
            <FileUploadButton onFileChange={handleFileAttached}
                              isTransparent
                              accept={"application/json"}
                              isDisabled={busy}
                              multiple={false}
            />
    );
};

export default RossumUploadResult;